/**
 * RC 1.47.5 Phase 3 — operator-confirmed ±5 variance tooltip copy.
 *
 * Single source of truth for the verbatim string. Imported by both
 * <ScoreVariancePill /> (production component) and the corresponding
 * Jest contract test. The constant is split out here so the test can
 * verify the copy without dragging in the JSX render path (which uses
 * the @/components/ui/tooltip alias that CRA's Jest config does not
 * resolve).
 *
 * Any change to this string requires explicit operator sign-off.
 */

export const TOOLTIP_COPY =
  'NDOR scores are directional assessments. Small movements within ' +
  '\u00b15 points are typically not materially significant and may ' +
  'reflect normal scoring variance rather than meaningful candidate ' +
  'deterioration.';
